<div class="row d-flex justify-content-center mb-3">
  <div class="col-10">{{ 'SELECT_THE_PLATFORM_LANGUAGE' | translate }}</div>
  
  <div class="col-10 mt-3 m-0" *ngFor="let item of languages">
    <div class="form-check p-0">
      <input 
        type="checkbox"
        class="d-none"
        autocomplete="off"
        id="{{item.code}}"> <!-- უნიკალური id -->
      <label 
        class="btn btn-portal border d-flex align-items-center" 
        for="{{item.code}}" 
        [ngClass]="{'form-check-label-active' : item.code === selectedLanguage}" 
        (click)="changeLanguage(item.code)"> <!-- გადაეცემა კოდი პირდაპირ -->
        <img [src]="item.img" class="w-20 rounded mx-2">
        {{ item.name }}
        <!-- <fa-icon *ngIf="item.code === selectedLanguage.code" [icon]="faCheck" class="check text-success"></fa-icon> -->
      </label>
    </div>

  </div>
</div>